import BRAND from './brand';
import type { Service, Feature, ProcessStep, Testimonial, FeatureSlide, Location } from './types';
import {
  SparklesIcon, SparklesSolidIcon, HomeIcon, BuildingOfficeIcon, TruckIcon,
  MovingBoxIcon, ShieldCheckIcon, ThumbUpIcon, UsersIcon,
  PhoneArrowUpRightIcon, CalendarDaysIcon, CheckBadgeIcon,
  HeartIcon, LockClosedIcon, CheckCircleIcon
} from './components/IconComponents';

// FIX: Added BUSINESS_HOURS constant required by CalendarBooking component.
export const BUSINESS_HOURS = {
  start: 9, // 9 AM
  end: 17, // 5 PM
};

// FIX: Added MOCKED_BOOKED_SLOTS constant required by CalendarBooking component.
export const MOCKED_BOOKED_SLOTS = new Set<string>([
  // Example: 'YYYY-MM-DD-HH'
]);

export const SERVICES: Service[] = [
  {
    icon: SparklesSolidIcon,
    title: 'Haircut',
    description: 'Classic cut, skin fade, or taper — finished clean with a hot towel.',
    duration: 45,
    reservationFee: 10,
  },
  {
    icon: CheckBadgeIcon,
    title: 'Haircut + Beard',
    description: 'The full service: precision cut plus beard shape-up and razor line work.',
    duration: 60,
    reservationFee: 15,
  },
  {
    icon: UsersIcon,
    title: 'Kids Cut (12 & under)',
    description: 'Patient, clean cuts for the young ones. First-cut friendly.',
    duration: 30,
    reservationFee: 5,
  },
  {
    icon: HeartIcon,
    title: 'Beard Trim & Shape',
    description: 'Beard sculpting, sharp lines, and conditioning treatment.',
    duration: 30,
    reservationFee: 5,
  },
];

export const FEATURE_SLIDES: FeatureSlide[] = [
  {
    image: '/images/hero.svg',
    video: '',
    title: `The ${BRAND.shortName} Standard`,
    subtitle: 'Every Cut, Every Chair',
    description: 'Precision fades, sharp line-ups, and hot towel finishes from barbers who take their craft seriously. You leave sharp — every single time.',
    features: [
      { icon: CheckBadgeIcon, text: 'Licensed, Experienced Barbers' },
      { icon: SparklesIcon, text: 'Hot Towel Finish On Every Cut' },
      { icon: HeartIcon, text: 'First-Cut Friendly For Kids' },
    ],
  },
  {
    image: '/images/hero.svg',
    video: '',
    title: 'Your Chair Is Ready When You Are',
    subtitle: 'Book Online, Skip The Wait',
    description: 'Pick your service, pick your time, lock it with a small deposit. No sitting around the shop for an hour — your barber is ready the minute you walk in.',
    features: [
      { icon: CalendarDaysIcon, text: 'Real-Time Online Booking' },
      { icon: LockClosedIcon, text: 'Small Deposit Holds Your Spot' },
      { icon: PhoneArrowUpRightIcon, text: 'Text Reminders Before Your Cut' },
    ],
  },
  {
    image: '/images/hero.svg',
    video: '',
    title: 'Walk-Ins Still Welcome',
    subtitle: 'Old-School Service, New-School Convenience',
    description: 'Booking gets you priority, but the door is always open. Swing by, put your name in, and we will get you in the next open chair.',
    features: [
      { icon: UsersIcon, text: 'All Ages, All Styles' },
      { icon: ThumbUpIcon, text: 'Straightforward Prices' },
      { icon: CheckCircleIcon, text: 'Satisfaction Guaranteed' },
    ],
  },
];


export const HOW_IT_WORKS_STEPS: ProcessStep[] = [
  {
    icon: PhoneArrowUpRightIcon,
    title: '1. Pick Your Service',
    description: 'Haircut, cut and beard, kids cut, or a beard shape-up — choose what you need and see the price up front. No surprises at the register.',
  },
  {
    icon: CalendarDaysIcon,
    title: '2. Lock In Your Time',
    description: 'Choose a day and time that works. A small deposit holds your chair — it comes off your total when you pay.',
  },
  {
    icon: CheckBadgeIcon,
    title: '3. Sit Down, Walk Out Sharp',
    description: 'Your barber is ready when you arrive. Fresh cut, clean line-up, hot towel finish — back on the street looking right.',
  },
];

export const TESTIMONIALS: Testimonial[] = [
  { quote: "Cleanest fade I've had in years. In and out in 40 minutes because I booked ahead.", author: 'Marcus', role: 'Regular', rating: 5 },
  { quote: 'They took their time with my son\'s first haircut. Patient and professional.', author: 'Danielle', role: 'Parent', rating: 5 },
  { quote: 'Beard work is precise every single time. The hot towel finish is worth it alone.', author: 'Anthony', role: 'Regular', rating: 5 },
  { quote: 'Booking online with a small deposit means my chair is actually ready when I arrive.', author: 'Kevin', role: 'Client', rating: 5 },
];
export const LOCATIONS: Location[] = [
  {
    state: BRAND.serviceArea,
    cities: [],
    image: '/images/hero.svg',
  },
];

